// extracted by mini-css-extract-plugin
var _1 = "PdlsJttAI2sKlq5XNqGe";
var _2 = "MBeviUzQT0STSKpseeI5";
export { _1 as "bottomOfBox", _2 as "whiteText" }
